import React from "react";
import Notification from "../../_rc-notification-3.0.0";
import Icon from "../icon";

let defaultDuration = 2;
let defaultTop;
let messageInstance;
let key = 1;
let prefixCls = "ant-message";
function noop() {}
function isObject(obj) {
  return Object.prototype.toString.call(obj) === "[object Object]";
}

function isFunction(fn) {
  return typeof fn === "function";
}
function getMessageInstance(callback) {
  if (messageInstance) {
    callback(messageInstance);
    return;
  }
  Notification.newInstance(
    {
      prefixCls,
      transitionName: "move-up",
      style: { top: defaultTop } // 覆盖原来的样式
    },
    instance => {
      if (messageInstance) {
        callback(messageInstance);
        return;
      }
      messageInstance = instance;
      callback(instance);
    }
  );
}
function getEcodeConfigProps(newProps = {}) {
  const name = "message.config";
  if (isObject(window.pcComponentsConfig) && window.pcComponentsConfig[name]) {
    const overwrite = window.pcComponentsConfig[name];
    if (isObject(overwrite)) {
      const propsFn = overwrite.overwritePropsFn;
      if (isFunction(propsFn)) {
        const overwriteProps = propsFn(newProps, name);
        if (isObject(overwriteProps)) {
          newProps = { ...newProps, ...overwriteProps };
        }
      }
    }
  }
  return newProps;
}
function getEcodeProps(newProps = {}) {
  const name = "message";
  if (isObject(window.pcComponentsConfig) && window.pcComponentsConfig[name]) {
    const overwrite = window.pcComponentsConfig[name];
    if (isObject(overwrite)) {
      const propsFn = overwrite.overwritePropsFn;
      if (isFunction(propsFn)) {
        const overwriteProps = propsFn(newProps, name);
        if (isObject(overwriteProps)) {
          newProps = { ...newProps, ...overwriteProps };
        }
      }
    }
  }
  return newProps;
}
function notice(content, duration = defaultDuration, type, onClose) {
  if (!content) return;
  onClose = onClose || noop;
  let iconType = {
    info: "info-circle",
    success: "check-circle",
    error: "cross-circle",
    warning: "exclamation-circle",
    loading: "loading"
  }[type];

  const target = key++;
  const props = getEcodeProps({
    duration,
    content,
    onClose,
    type,
    iconType
  });
  getMessageInstance(instance => {
    instance.notice({
      ...props,
      key: target,
      style: {},
      content: (
        <div
          className={`${prefixCls}-custom-content ${prefixCls}-${props.type}`}
        >
          <Icon type={props.iconType} />
          <span>{props.content}</span>
          <div
            className={`${prefixCls}-custom-close`}
            onClick={() => {
              if (messageInstance) {
                messageInstance.removeNotice(target);
              }
            }}
          >
            <Icon type="cross-circle" />
          </div>
        </div>
      )
    });
  });
  return () => {
    if (messageInstance) {
      messageInstance.removeNotice(target);
    }
  };
}

export default {
  info(content, duration, onClose) {
    return notice(content, duration, "info", onClose);
  },
  success(content, duration, onClose) {
    return notice(content, duration, "success", onClose);
  },
  error(content, duration, onClose) {
    return notice(content, duration, "error", onClose);
  },
  // Departed usage, please use warning()
  warn(content, duration, onClose) {
    return notice(content, duration, "warning", onClose);
  },
  warning(content, duration, onClose) {
    return notice(content, duration, "warning", onClose);
  },
  loading(content, duration, onClose) {
    return notice(content, duration, "loading", onClose);
  },
  config(options) {
    if ("top" in options) {
      defaultTop = options.top;
    }
    if ("duration" in options) {
      defaultDuration = options.duration;
    }
    if ("prefixCls" in options) {
      prefixCls = options.prefixCls;
    }
    const configOptions = getEcodeConfigProps(options);
    if ("top" in configOptions) {
      defaultTop = configOptions.top;
    }
    if ("duration" in configOptions) {
      defaultDuration = configOptions.duration;
    }
  },
  destroy() {
    if (messageInstance) {
      messageInstance.destroy();
      messageInstance = null;
    }
  }
};



// WEBPACK FOOTER //
// ./_antd1.11.2/message/index.jsx